import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

export const logout = defaultApi.declareEndpoint({
  url: 'authentication/v1/logout/',
  method: 'GET',
  responseSchema: z.string(),
});
